import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

import IconButton from 'components/common/IconButton';

import pxToRem from 'styles/pxToRem';
import hexToRgb from 'styles/hexToRgb';

const styles = theme => ({
  root: {
    position: 'relative',
    padding: 0,
    border: `1px solid ${theme.palette.grey[600]}`,
  },
  hidden: {
    border: 'none',
    opacity: 0,
  },
  today: {
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '50%',
      bottom: 6,
      marginLeft: -3,
      width: 4,
      height: 4,
      border: `1px solid ${theme.palette.common.white}`,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary[500],
      zIndex: '1',
    },
  },
  button: {
    width: 38,
    height: 38,
    fontSize: pxToRem(12),
    borderRadius: 0,
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.common.white,
      backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.75)`,
    },
  },
  buttonDisabled: {
    pointerEvents: 'none',
  },
  buttonActive: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary[500],
  },
  buttonInRange: {
    color: theme.palette.common.white,
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.5)`,
  },
  buttonInActiveRange: {
    color: theme.palette.common.white,
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.5)`,
    '&$buttonActive': {
      backgroundColor: theme.palette.primary[500],
    },
  },
});

const DatepickerDay = (props) => {
  const {
    classes,
    day,
    disabled,
    hidden,
    active,
    inRange,
    inActiveRange,
    today,
    onSelect,
    onBlur,
    onMouseOver,
    onMouseOut,
    disableTabFocus,
  } = props;

  return (
    <TableCell
      className={classNames(classes.root, {
        [classes.hidden]: hidden,
        [classes.today]: today,
      })}
      padding="none"
    >
      {!hidden &&
        <IconButton
          className={classNames(classes.button, {
            [classes.buttonDisabled]: disabled,
            [classes.buttonInRange]: inRange,
            [classes.buttonInActiveRange]: inActiveRange,
            [classes.buttonActive]: active,
          })}
          disabled={disabled}
          onClick={() => onSelect(day)}
          onBlur={onBlur}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
          {...disableTabFocus ? { tabIndex: -1 } : {}}
        >
          <span>
            {day.format('DD')}
          </span>
        </IconButton>
      }
    </TableCell>
  );
};

DatepickerDay.propTypes = {
  day: PropTypes.instanceOf(Moment).isRequired,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  inRange: PropTypes.bool,
  inActiveRange: PropTypes.bool,
  hidden: PropTypes.bool,
  today: PropTypes.bool,
  onSelect: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  disableTabFocus: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    hidden: PropTypes.string.isRequired,
    today: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    buttonDisabled: PropTypes.string.isRequired,
    buttonActive: PropTypes.string.isRequired,
    buttonInActiveRange: PropTypes.string.isRequired,
  }).isRequired,
};

DatepickerDay.defaultProps = {
  disabled: false,
  active: false,
  inRange: false,
  inActiveRange: false,
  hidden: false,
  today: false,
  disableTabFocus: false,
  onSelect: () => {},
  onBlur: () => {},
  onMouseOver: () => {},
  onMouseOut: () => {},
};

export default withStyles(styles)(DatepickerDay);



// WEBPACK FOOTER //
// ./src/components/fields/DatepickerField/DatepickerDay.js